import { Badge, Table } from 'react-bootstrap';
import './MercurXTransactionTable.scss';
import { connect } from 'react-redux';
import MercurXIcons from '../MercurXIcons/MercurXIcons';
import { mainColors } from '../../helpers/colors';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { setAlertAction } from '../../store/alert/alertActions';
import {
  setTransactionsSortDataAction,
  sortTransactionsAction,
} from '../../store/transaction/transactionActions';
import useMercurxPagination from '../../hooks/useMercurxPagination';
import MercurXTablePagination from '../MercurXTablePagination/MercurXTablePagination';
import MercurXSortableHeader from '../MercurXSortableHeader/MercurXSortableHeader';
import {
  TRANSACTIONS_SORT_KEYS,
  TRANSACTIONS_SORT_TYPES,
} from '../../pages/Transactions/transactionsConstants';

function MercurXTransactionTable(props) {
  const {
    transactions,
    filteredTransactions,
    transactionsSortData,
    setTransactionsSortData,
    sortTransactions,
    setAlert,
  } = props;
  const sourceData = filteredTransactions || transactions || [];
  const {
    currentPage,
    totalPages,
    visiblePages,
    pagedData: renderedTransactions,
    rowOffset,
    isFirstPage,
    isLastPage,
    goToPage,
    goToFirstPage,
    goToPrevPage,
    goToNextPage,
    goToLastPage,
  } = useMercurxPagination(sourceData, 10, 5);

  function scrollToTransactionsContainer() {
    const transactionsContainer = document.getElementById('transactions-container');
    if (transactionsContainer) {
      transactionsContainer.scrollIntoView({ behavior: 'smooth' });
    }
  }

  const handlePageChange = (page) => {
    goToPage(page);
    scrollToTransactionsContainer();
  };

  const handleFirstPage = () => {
    goToFirstPage();
    scrollToTransactionsContainer();
  };

  const handlePrevPage = () => {
    goToPrevPage();
    scrollToTransactionsContainer();
  };

  const handleNextPage = () => {
    goToNextPage();
    scrollToTransactionsContainer();
  };

  const handleLastPage = () => {
    goToLastPage();
    scrollToTransactionsContainer();
  };

  function formatDate(dateString) {
    const options = {
      year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short'
    };
    const formattedDate = new Intl.DateTimeFormat('default', options).format(new Date(dateString));
    return formattedDate;
  }
  function calculateFormat(x) {

    const formatBalance = (Math.floor((Number(x) / 10000) * 100) / 100).toString().split('.');

    const firstValueFormatBalance = Number(formatBalance[0]).toLocaleString('tr-TR');
    const secondValueFormatBalance = formatBalance[1] || "0";
    return firstValueFormatBalance + ',' + secondValueFormatBalance;
  }
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        setAlert({
          title: 'Success!',
          text: 'Wallet Address Copied To Clipboard',
          variant: 'success',
          outTimeMS: 3000,
        });
      })
      .catch(err => {
        console.error('Failed to copy text: ', err);
      });
  };

  const handleSort = (sortKey, defaultSortType) => {
    const nextSortType = transactionsSortData.sortKey === sortKey
      ? (transactionsSortData.sortType === TRANSACTIONS_SORT_TYPES.ASCENDING
        ? TRANSACTIONS_SORT_TYPES.DESCENDING
        : TRANSACTIONS_SORT_TYPES.ASCENDING)
      : defaultSortType;

    setTransactionsSortData({
      sortKey,
      sortType: nextSortType,
    });
    sortTransactions();
  };

  return (
    <>
      <Table className="transactions-table-design" responsive hover borderless>
        <thead>
          <tr className="text-t-body-color text-fs-tag">
            <th>#</th>
            <th>
              <MercurXSortableHeader
                label="Project Name"
                isActive={transactionsSortData.sortKey === TRANSACTIONS_SORT_KEYS.PROJECT_NAME}
                isAscending={transactionsSortData.sortType === TRANSACTIONS_SORT_TYPES.ASCENDING}
                onClick={() => handleSort(
                  TRANSACTIONS_SORT_KEYS.PROJECT_NAME,
                  TRANSACTIONS_SORT_TYPES.ASCENDING
                )}
              />
            </th>
            <th>
              <MercurXSortableHeader
                label="Action"
                isActive={transactionsSortData.sortKey === TRANSACTIONS_SORT_KEYS.ACTION}
                isAscending={transactionsSortData.sortType === TRANSACTIONS_SORT_TYPES.ASCENDING}
                onClick={() => handleSort(
                  TRANSACTIONS_SORT_KEYS.ACTION,
                  TRANSACTIONS_SORT_TYPES.ASCENDING
                )}
              />
            </th>
            <th>
              <MercurXSortableHeader
                label="Token Count"
                isActive={transactionsSortData.sortKey === TRANSACTIONS_SORT_KEYS.TOKEN_COUNT}
                isAscending={transactionsSortData.sortType === TRANSACTIONS_SORT_TYPES.ASCENDING}
                onClick={() => handleSort(
                  TRANSACTIONS_SORT_KEYS.TOKEN_COUNT,
                  TRANSACTIONS_SORT_TYPES.DESCENDING
                )}
              />
            </th>
            <th>
              <MercurXSortableHeader
                label="User Public Address"
                isActive={
                  transactionsSortData.sortKey === TRANSACTIONS_SORT_KEYS.USER_PUBLIC_ADDRESS
                }
                isAscending={transactionsSortData.sortType === TRANSACTIONS_SORT_TYPES.ASCENDING}
                onClick={() => handleSort(
                  TRANSACTIONS_SORT_KEYS.USER_PUBLIC_ADDRESS,
                  TRANSACTIONS_SORT_TYPES.ASCENDING
                )}
              />
            </th>
            <th>
              <MercurXSortableHeader
                label="Token Address"
                isActive={transactionsSortData.sortKey === TRANSACTIONS_SORT_KEYS.TOKEN_ADDRESS}
                isAscending={transactionsSortData.sortType === TRANSACTIONS_SORT_TYPES.ASCENDING}
                onClick={() => handleSort(
                  TRANSACTIONS_SORT_KEYS.TOKEN_ADDRESS,
                  TRANSACTIONS_SORT_TYPES.ASCENDING
                )}
              />
            </th>
            <th>
              <MercurXSortableHeader
                label="Txn Hash"
                isActive={transactionsSortData.sortKey === TRANSACTIONS_SORT_KEYS.TRANSACTION_HASH}
                isAscending={transactionsSortData.sortType === TRANSACTIONS_SORT_TYPES.ASCENDING}
                onClick={() => handleSort(
                  TRANSACTIONS_SORT_KEYS.TRANSACTION_HASH,
                  TRANSACTIONS_SORT_TYPES.ASCENDING
                )}
              />
            </th>
            <th>
              <MercurXSortableHeader
                label="Txn Date"
                isActive={transactionsSortData.sortKey === TRANSACTIONS_SORT_KEYS.CREATE_DATE}
                isAscending={transactionsSortData.sortType === TRANSACTIONS_SORT_TYPES.ASCENDING}
                onClick={() => handleSort(
                  TRANSACTIONS_SORT_KEYS.CREATE_DATE,
                  TRANSACTIONS_SORT_TYPES.DESCENDING
                )}
              />
            </th>
            <th>
              <MercurXSortableHeader
                label="Status"
                isActive={
                  transactionsSortData.sortKey === TRANSACTIONS_SORT_KEYS.TRANSACTION_STATUS
                }
                isAscending={transactionsSortData.sortType === TRANSACTIONS_SORT_TYPES.ASCENDING}
                onClick={() => handleSort(
                  TRANSACTIONS_SORT_KEYS.TRANSACTION_STATUS,
                  TRANSACTIONS_SORT_TYPES.DESCENDING
                )}
              />
            </th>
          </tr>
        </thead>
        {renderedTransactions?.length ? (
          <tbody>
            {renderedTransactions.map((item, index) => {
              return (
                <tr
                  className="text-t-head-color"
                  key={item.transaction_hash || `${item.cdate}-${index}`}
                >
                  <td>{rowOffset + index + 1}</td>
                  <td>{item.project_name}</td>
                  <td>{item.action}</td>
                  <td>
                    {item.action === 'staking' ? (
                      <>{item.token_count}</>
                    ) : (
                      <>{calculateFormat(item.token_count)}</>
                    )}
                  </td>
                  <td>
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id={`tooltip-${index}`}>
                        {item.user_public_address}</Tooltip>}
                    >
                      <span
                        className="copyable-text"
                        onClick={() => copyToClipboard(item.user_public_address)}
                      >
                        {`${item.user_public_address.slice(0, 3)}...${
                          item.user_public_address.slice(-3)}`}
                      </span>
                    </OverlayTrigger>
                  </td>

                  <td>
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id={`tooltip-${index}`}>
                        {item.token_address}</Tooltip>}
                    >
                      <span
                        className="copyable-text"
                        onClick={() => copyToClipboard(item.token_address)}
                      >
                        {`${item.token_address.slice(0, 3)}...${item.token_address.slice(-3)}`}
                      </span>
                    </OverlayTrigger>
                  </td>

                  <td>
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id={`tooltip-${index}`}>
                        {item.transaction_hash}</Tooltip>}
                    >
                      <span
                        className="copyable-text"
                        onClick={() => copyToClipboard(item.transaction_hash)}
                      >
                        {`${item.transaction_hash.slice(0, 3)}...${
                          item.transaction_hash.slice(-3)}`}
                      </span>
                    </OverlayTrigger>
                  </td>

                  <td>{formatDate(item.cdate)}</td>
                  <td>
                    {item.transaction_status ? (
                      <Badge bg="success">True</Badge>
                    ) : (
                      <Badge bg="danger">False</Badge>
                    )}
                  </td>

                  <td>
                    <p className="border-bottom-detail mt-1">
                      <a
                        href={'https://testnet.bscscan.com/tx/' + item.transaction_hash}
                        target="_blank"
                        rel="noreferrer"
                        className="link"
                      >
                        <MercurXIcons
                          name="BsFillInfoSquareFill"
                          size={18}
                          color={mainColors.primary}
                        />
                      </a>
                    </p>
                  </td>
                </tr>
              );
            })}
          </tbody>
        ) : null}
      </Table>
      {!renderedTransactions?.length && (
        <div className="d-flex text-fs-body-md text-t-body-color justify-content-center">
          No transaction found according to search results.
        </div>
      )}
      <MercurXTablePagination
        currentPage={currentPage}
        totalPages={totalPages}
        visiblePages={visiblePages}
        isFirstPage={isFirstPage}
        isLastPage={isLastPage}
        onFirstPage={handleFirstPage}
        onPrevPage={handlePrevPage}
        onPageChange={handlePageChange}
        onNextPage={handleNextPage}
        onLastPage={handleLastPage}
      />
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    transactions: state.transactionReducer.transactions,
    filteredTransactions: state.transactionReducer.filteredTransactions,
    transactionsSortData: state.transactionReducer.transactionsSortData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setTransactionsSortData: (payload) => {
      dispatch(setTransactionsSortDataAction(payload));
    },
    sortTransactions: () => {
      dispatch(sortTransactionsAction());
    },
    setAlert: (payload) => {
      dispatch(setAlertAction(payload));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(MercurXTransactionTable);
